import PhotoSwipe from 'photoswipe';
import PhotoSwipeUiDefault from 'photoswipe/dist/photoswipe-ui-default';

export default class GalleryModal {
  constructor() {
    this.modalTarget = document.querySelector('[data-pswp]');
    this.modal = '';
  }

  init(imageArray, selectedIndex = 0) {
    if (!this.modalTarget) { return; }

    const options = {
      index: selectedIndex,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false,
      counterEl: false,
      arrowEl: true,
      preloaderEl: false,
      closeOnScroll: false,
      showHideOpacity: true,
      history: false,
      loop: true,
      clickToCloseNonZoomable: false,
      timeToIdle: false,
      timeToIdleOutside: false,
    };

    this.modal = new PhotoSwipe(this.modalTarget, PhotoSwipeUiDefault, imageArray, options);
    this.modal.init();
  }

  destroy() {
    if (this.modal) {
      this.modal.destroy();
    }
  }
}
